import { render } from "./LandownerProfileUpdate.vue?vue&type=template&id=2f05d7dd&scoped=true&ts=true&lang=pug"
import script from "./LandownerProfileUpdate.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandownerProfileUpdate.vue?vue&type=script&lang=ts&setup=true"

import "./LandownerProfileUpdate.vue?vue&type=style&index=0&id=2f05d7dd&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f05d7dd"]])

export default __exports__